import React from 'react';
import { Styles } from '../styles/coursePrice.js';

const CoursePrice = ({
    priceBuckets = [],
    loading,
    selectedPrice = '',
    onTogglePrice = () => {}
}) => {
    const displayBuckets = React.useMemo(() => {
        if (!selectedPrice) {
            return priceBuckets;
        }
        const exists = priceBuckets.some((bucket) => bucket.id === selectedPrice);
        if (exists || selectedPrice === 'all') {
            return priceBuckets;
        }
        return [...priceBuckets, { id: selectedPrice, label: selectedPrice, count: 0 }];
    }, [priceBuckets, selectedPrice]);

    return (
        <Styles>
            <div className="course-price">
                <h5>Course Price</h5>
                {loading ? (
                    <p className="loading text-muted">Loading price ranges…</p>
                ) : displayBuckets.length === 0 ? (
                    <p className="empty text-muted">No tuition data available.</p>
                ) : (
                    <ul className="price-item list-unstyled">
                        {displayBuckets.map((bucket) => {
                            const isSelected =
                                (bucket.id === 'all' && !selectedPrice) ||
                                (bucket.id !== 'all' && selectedPrice === bucket.id);
                            return (
                                <li
                                    className={`check-btn${isSelected ? ' active' : ''}`}
                                    key={bucket.id}
                                >
                                    <label>
                                        <input
                                            type="checkbox"
                                            className="check-box"
                                            checked={isSelected}
                                            onChange={() => onTogglePrice(bucket.id)}
                                            aria-checked={isSelected}
                                        />
                                        {bucket.label}
                                        <span>({bucket.count})</span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </Styles>
    );
};

export default CoursePrice;
